<template>
    <div class="flex w-full flex-col gap-4">
        <h1 class="text-xl leading-none">
            {{ modalTitle }}
        </h1>
        <FormKit type="form" :actions="false" form-class="w-full" @submit="testSubmit">
            <div class="flex flex-col gap-4">
                <FormKit
                    v-model="noteRef"
                    name="note"
                    type="textarea"
                    validation="length:0,255"
                    validation-visibility="live"
                    :validation-messages="{
                        length: 'Note cannot be more than 255 characters.'
                    }"
                />
                <FormKit
                    type="submit"
                >
                    {{ modalTitle }}
                </FormKit>
            </div>
        </FormKit>
    </div>
</template>

<script setup lang="ts">
    import type { ProductNote } from '~/types/local-types'
    import cloneDeep from 'lodash.clonedeep'
    import { cart } from '~/store/cart'
    const props = defineProps<ProductNote>()
    const { t } = useI18n()
    const modalTitle = !cart().cart.products[props.cartProductIndex]?.note || cart().cart.products[props.cartProductIndex].note === '' ? t('checkoutPage.payment.ADDremarks') : t('checkoutPage.payment.changeComment')
    const noteRef = ref(cloneDeep(cart().cart.products[props?.cartProductIndex].note))
    function testSubmit () {
        const updateObject = {
            ...cloneDeep(cart().cart.products[props.cartProductIndex]),
            note: noteRef.value
        }
        cart().updateProduct(updateObject, props.cartProductIndex)
        props.closeModal()
    }
</script>
